import { render, staticRenderFns } from "./Login-admin.vue?vue&type=template&id=2025e518&scoped=true&"
import script from "./Login-admin.vue?vue&type=script&lang=js&"
export * from "./Login-admin.vue?vue&type=script&lang=js&"
import style0 from "./Login-admin.vue?vue&type=style&index=0&id=2025e518&prod&scoped=true&lang=css&"
import style1 from "./Login-admin.vue?vue&type=style&index=1&id=2025e518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025e518",
  null
  
)

export default component.exports